import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsHelpbuttonDaoService {

  private BASE_URL = environment.apiURL;
  private OPTIONS = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json; charset=UTF-8'
    })
  };

  constructor( private http: HttpClient ) { }

  public getDepartments(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_getSections', item, options);
  }

  public getDepartmentsCounts(context, lang, udid) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    return this.http.get(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/count', options);
  }

  public getDepartmentInfo(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_getSectionDetails', item, options);
  }

  public addNewDepartment(context, lang, udid, active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, location, sectionName, sectionImageRaw, sectionImageName, askName) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, location, sectionName, sectionImageRaw, sectionImageName, askName };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_saveSection', item, options);
  }

  public updateSection(context, lang, udid, active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, internalId, location, sectionName, askName) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, internalId, location, sectionName, askName };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_saveSection', item, options);
  }

  public deleteDepartment(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_deleteSection', item, options);
  }

  public updateImageDepartment(context, lang, udid, internalId, imageRaw) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, imageRaw };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_updateImageSection', item, options);
  }

  public getGroups(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_getGroupList', item, options);
  }

  public saveGroupSeconds(context, lang, udid, groupInternalId, seconds) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { groupInternalId, seconds };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_saveGroupSeconds', item, options);
  }

  public saveStaffGroupRelation(context, lang, udid, groupInternalId, staffInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { groupInternalId, staffInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_saveStaffGroupRelation', item, options);
  }

  public removeStaffAndGroupRelation(context, lang, udid, groupInternalId, staffInternalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { groupInternalId, staffInternalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_removeStaffAndGroupRelation', item, options);
  }

  public getDepartmentDevices(context, lang, udid, internalId) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_listDevicesForHelpButtonSections', item, options);
  }

  public saveDepartmentDevices(context, lang, udid, internalId, devicesBound) {
    const options = {};
    Object.assign(options, this.OPTIONS);
    options['headers'] = options['headers'].append('context', context);
    options['headers'] = options['headers'].append('lang', lang);
    options['headers'] = options['headers'].append('udid', udid);
    const item = { internalId, devicesBound };
    return this.http.post(this.BASE_URL + 'private/v2.0/helpButtonSectionMaintenance/ws_saveDevicesForHelpButtonSections', item, options);
  }
}
